"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterProducts = void 0;
var _filterData = require("./filterData");
const filterProducts = products => products.filter(_filterData.filterData);
exports.filterProducts = filterProducts;
//# sourceMappingURL=filterProducts.js.map